// extracted by css-extract-rspack-plugin
export default {"spaceXSmall":"8px","container":"title-widget__container___ATTON"};